import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox as ShadCheckbox } from '@dashboard/components/ui/checkbox';
import { cn } from '@dashboard/lib/utils';

const propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.bool,
  checked: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  onChange: PropTypes.func,
};

const defaultProps = {
  required: false,
  label: '',
};

const Checkbox = props => {
  const { name, id, required, value, checked, label, onChange, className, ...rest } = props;

  const isChecked = checked !== undefined ? checked : value;

  const handleCheckedChange = nextChecked => {
    if (!onChange) return;
    onChange({
      target: {
        name,
        id,
        checked: nextChecked === true,
        value: nextChecked === true,
        type: 'checkbox',
      },
      currentTarget: {
        name,
        id,
        checked: nextChecked === true,
        value: nextChecked === true,
        type: 'checkbox',
      },
    });
  };

  const input = (
    <ShadCheckbox
      {...rest}
      name={name}
      id={id}
      required={required}
      checked={Boolean(isChecked)}
      onCheckedChange={handleCheckedChange}
      className={cn(className)}
    />
  );

  if (label) {
    return (
      <label className="inline-flex items-center gap-x-2 cursor-pointer">
        {input}
        <span className="text-gray-900 dark:text-foreground text-sm font-medium">{label}</span>
      </label>
    );
  }

  return input;
};

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;

export default Checkbox;
